// client/src/routes/_auth/confirm-email-change.$token.tsx — „Confirmarea adresei noi" · D-2981.
//
// The path is the server's, not this file's: `RequestEmailChangeCommandHandler` composes
// `{origin}/confirm-email-change/{token}` with nothing after the token, and every change mail ever
// sent points at exactly that, so the spelling is fixed.
//
// Under the pathless `_auth` layout, the frame for a page opened from a mail. Nobody is redirected
// away from here: the link is usually opened in a browser that holds no session, and when one is
// held the change still applies to the account the link names, whoever is signed in. The route
// bootstraps the session, as `/verify-email/$token` does, so the page can offer „Continuați" to a
// visitor who holds one and re-read it after the address moves.

import { createFileRoute } from '@tanstack/react-router';

import { ConfirmEmailChange } from '@/features/auth/ConfirmEmailChange';
import { ensureSession } from '@/session';

export const Route = createFileRoute('/_auth/confirm-email-change/$token')({
  beforeLoad: async () => {
    await ensureSession();
  },
  component: ConfirmEmailChangeScreen,
});

function ConfirmEmailChangeScreen() {
  const { token } = Route.useParams();
  return <ConfirmEmailChange token={token} />;
}
